"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterOutWarningsFromAnchorUntilCycleIsFixed = exports.emptyWarnings = void 0;
exports.emptyWarnings = [];
function filterOutWarningsFromAnchorUntilCycleIsFixed(nodeId, upstream) {
    return upstream === null || upstream === void 0 ? void 0 : upstream.filter(function (w) { var _a; return ((_a = w.asset) === null || _a === void 0 ? void 0 : _a.id) !== nodeId; });
}
exports.filterOutWarningsFromAnchorUntilCycleIsFixed = filterOutWarningsFromAnchorUntilCycleIsFixed;
//# sourceMappingURL=DataQualityWarningCycleTemporaryFix.js.map